import React, { useState, useRef, useEffect } from "react";

import LayoutCard from "../../Layout/Layout";

import CompareSvg from "../../../../images/compare-assessment.svg"



import AssessmentFilter from "./AssessmentFilter/index.jsx";
import useOrientationChange from "../../../Utils/useOrientationChange.jsx";

const CompareAssesments = () => {


  useOrientationChange()


  return (
    <LayoutCard
      headerIcon={CompareSvg}
      headerText="Compare Assessments"
      CompareAssessment={true}
    >
      <AssessmentFilter />
    </LayoutCard>
  );
};

export default CompareAssesments;



// WEBPACK FOOTER //
// ./src/new/Components/Reports/CompareAssessment/Compare-Assessment.jsx